<template>
    <div class="page" :class="{ 'page__has-bar': !readonly }">
        <div class="page__bd">
            <div class="form-preview weui-form-preview">
                <div class="weui-form-preview__hd">
                    <div class="weui-form-preview__item">
                        <label class="weui-form-preview__label">考试编号</label>
                        <em class="weui-form-preview__value">{{ form.main.ex_code }}</em>
                    </div>
                </div>
                <div class="weui-form-preview__bd">
                    <custom-layout :view-config="customViewConfig">
                        <div class="weui-form-preview__item" slot="ex_name">
                            <label class="weui-form-preview__label">{{ customLabel.ex_name || "考试名称" }}</label>
                            <em class="weui-form-preview__value">{{ form.main.ex_name }}</em>
                        </div>
                        <div class="weui-form-preview__item" slot="ex_type">
                            <label class="weui-form-preview__label">{{ customLabel.ex_type || "限制时间范围" }}</label>
                            <span class="weui-form-preview__value">{{ form.main.ex_type ? '是' : '否' }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="ex_begin" v-if="form.main.ex_begin">
                            <label class="weui-form-preview__label">{{ customLabel.ex_begin || "开始时间" }}</label>
                            <span class="weui-form-preview__value">{{ form.main.ex_begin }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="ex_end" v-if="form.main.ex_end">
                            <label class="weui-form-preview__label">{{ customLabel.ex_end || "结束时间" }}</label>
                            <span class="weui-form-preview__value">
                                {{ form.main.ex_end }}
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="ex_limit">
                            <label class="weui-form-preview__label">{{ customLabel.ex_limit || "限定时长" }}</label>
                            <span class="weui-form-preview__value">
                                {{ form.main.ex_limit }} 分钟
                            </span>
                        </div>
                        <div class="weui-form-preview__item" slot="ex_reviewer" v-if="form.main.ex_reviewer">
                            <label class="weui-form-preview__label">{{ customLabel.ex_reviewer || "阅卷人" }}</label>
                            <span class="weui-form-preview__value">{{ form.main.ex_reviewer }}</span>
                        </div>
                    </custom-layout>
                </div>
            </div>
            <collapse class="form-preview weui-form-preview" :title="'明细（' + form.items.length + '条）'">
                <div class="weui-form-preview__bd form-detail-preview" v-for="item in form.items" :key="item.id">
                    <div class="form-detail-preview_num">{{ item.eu_detno }}</div>
                    <custom-layout :view-config="customViewConfig" position="detail1">
                        <div class="weui-form-preview__item" slot="eu_emname">
                            <label class="weui-form-preview__label">{{ customLabel.eu_emname || "人员名称" }}</label>
                            <span class="weui-form-preview__value">{{ item.eu_emname }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="eu_epname">
                            <label class="weui-form-preview__label">{{ customLabel.eu_epname || "试卷名称" }}</label>
                            <span class="weui-form-preview__value">{{ item.eu_epname }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.eu_begin" slot="eu_begin">
                            <label class="weui-form-preview__label">{{ customLabel.eu_begin || "实际开始时间" }}</label>
                            <span class="weui-form-preview__value">{{ item.eu_begin }}</span>
                        </div>
                        <div class="weui-form-preview__item" v-if="item.eu_end" slot="eu_end">
                            <label class="weui-form-preview__label">{{ customLabel.eu_end || "实际完成时间" }}</label>
                            <span class="weui-form-preview__value">{{ item.eu_end }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="eu_status">
                            <label class="weui-form-preview__label">{{ customLabel.eu_status || "状态" }}</label>
                            <span class="weui-form-preview__value">{{ parseStatus(item.eu_status) }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="qty" v-if="item.eu_score != null">
                            <label class="weui-form-preview__label">{{ customLabel.eu_score || "得分" }}</label>
                            <span class="weui-form-preview__value">{{ item.eu_score }}</span>
                        </div>
                        <div class="weui-form-preview__item" slot="opt" v-if="item.eu_status">
                            <router-link :to="'/oa/exam_user/' + item.id">查看试卷</router-link>
                        </div>
                    </custom-layout>
                </div>
            </collapse>
        </div>

        <div class="footer-bar weui-dialog__ft" v-if="!readonly">
            <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_primary"
                @click="f_audit">审核</a>
            <a href="javascript:;" v-if="!editable" class="weui-dialog__btn weui-dialog__btn_primary"
                @click="f_unaudit">反审</a>
            <a href="javascript:;" v-if="editable" class="weui-dialog__btn weui-dialog__btn_default"
                @click="f_remove">删除</a>
        </div>
    </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import Collapse from "@/components/Collapse.vue";

export default {
    mixins: [process],
    components: {
        CustomLayout,
        Collapse
    },
    data() {
        return {
            baseUrl: "/api/oa/exam",
            codeField: "ex_code",
            statusField: "ex_statuscode",
            caller: "Exam",
            xtype: "oa-exam-formpanel",
        };
    },
    methods: {
        parseStatus(status) {
            return ['未考试', '已开始未完成', '已完成未批阅', '已完成已批阅'][status];
        }
    }
};
</script>